import * as React from 'react';
/**
 * @ignore - internal component.
 */
const FormControlContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}
export default FormControlContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/FormControl/FormControlContext.js
// module id = 271
// module chunks = 22